import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { fetchAuthSession } from 'aws-amplify/auth';

// GraphQL endpoint configuration
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_HASURA_ENDPOINT || 'http://localhost:8082/v1/graphql',
});

// Authentication link to add JWT token to requests
const authLink = setContext((_, { headers }) => {
  return fetchAuthSession()
    .then((session) => {
      const token = session.tokens?.idToken?.toString?.() || session.tokens?.accessToken?.toString?.() || '';
      const adminSecret = process.env.REACT_APP_HASURA_ADMIN_SECRET;

      return {
        headers: {
          ...headers,
          authorization: token ? `Bearer ${token}` : '',
          ...(adminSecret ? { 'x-hasura-admin-secret': adminSecret } : {}),
        }
      };
    })
    .catch(() => ({
      headers: {
        ...headers,
      }
    }));
});

// Configure Apollo Client
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'cache-and-network', 
      errorPolicy: 'all',
    },
  },
});

export default client;